import { resolveSpxThemeMode } from './ui';

function readToken(name, fallback) {
  if (typeof window === 'undefined' || typeof document === 'undefined') {
    return fallback;
  }

  const value = window.getComputedStyle(document.documentElement).getPropertyValue(name).trim();
  return value || fallback;
}

export function resolveSpxChartPalette() {
  return [
    readToken('--spx-color-brand-500', '#3b3a8f'),
    readToken('--spx-color-intelligence-500', '#3fa7c9'),
    readToken('--spx-color-success-500', '#1f9d55'),
    readToken('--spx-color-warning-500', '#c98512'),
    readToken('--spx-color-danger-500', '#c84545')
  ];
}

export function createSpxApexOptions(options = {}) {
  const theme = resolveSpxThemeMode();

  return {
    chart: {
      fontFamily: readToken('--spx-font-body', 'Plus Jakarta Sans, sans-serif'),
      toolbar: { show: false },
      ...options.chart
    },
    colors: options.colors || resolveSpxChartPalette(),
    theme: {
      mode: theme,
      ...options.theme
    },
    grid: {
      borderColor: readToken('--spx-border-subtle', 'rgba(71, 83, 109, 0.12)'),
      ...options.grid
    },
    tooltip: {
      theme,
      ...options.tooltip
    },
    ...options
  };
}

function parseSpxChartConfig(element) {
  const rawConfig = element.getAttribute('data-spx-chart');
  if (!rawConfig) {
    return null;
  }

  try {
    return JSON.parse(rawConfig);
  } catch (error) {
    console.warn('Invalid SchoolPlex chart config.', error);
    return null;
  }
}

export function mountSpxApexChart(element, config = null) {
  if (typeof window === 'undefined' || typeof window.ApexCharts !== 'function' || !element) {
    return null;
  }

  if (element.dataset.spxChartBound === 'true') {
    return element._spxApexChartInstance || null;
  }

  const resolvedConfig = config || parseSpxChartConfig(element);
  if (!resolvedConfig) {
    return null;
  }

  const chart = new window.ApexCharts(element, createSpxApexOptions(resolvedConfig));
  chart.render();

  element.dataset.spxChartBound = 'true';
  element._spxApexChartInstance = chart;

  return chart;
}

export function initSpxApexCharts(root = document) {
  if (typeof document === 'undefined' || typeof window === 'undefined' || typeof window.ApexCharts !== 'function') {
    return;
  }

  root.querySelectorAll('[data-spx-chart]').forEach((element) => {
    mountSpxApexChart(element);
  });
}
